export default class SendMailUserModel {
    public email = ''
    /**
     * L'url de base du client est envoyé à l'API pour construire le lien à envoyer par mail.
     * Cette url doit bien sur être présente dans le fichier de configuration de l'API.
     * Cette url peut être récuppéré à partir de routeMixin.baseUrl().
     */
    public baseUrl = ''

    constructor(email: string, baseUrl: string) {
        this.email = email
        this.baseUrl = baseUrl
    }
}
